module.exports = __webpack_public_path__ + "static/media/code.d3359f41.jpg";